<template>
  <div class="footer">
    <div class="container">
      <div class="footer-left">
        <div class="footer-company-title">
          <img alt="" class="footer-company-logo" src="@/assets/logo.webp" />
          <h3 class="footer-company-name">Actinobacteria TFDB</h3>
        </div>
        <div class="footer-company-info">
          <p class="footer-company-info__text">
            Address: Shanghai Meilong Road No. 130
          </p>
          <p class="footer-company-info__text">Postcode: 200237</p>
          <p class="footer-company-info__text">TEL:+86(021)64253832</p>
          <p class="footer-company-info__text">FAX:021-64253832</p>
        </div>
      </div>
      <div class="footer-right">
        <h3 class="footer-link-title">Quick Link</h3>
        <div class="footer-link-list">
          <div
            v-for="link in linkList"
            :key="link.name"
            class="footer-link-item"
          >
            <img :src="link.src" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright">
      Copyright © 华东理工大学 All rights reserved
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      linkList: [
        {
          name: "ncbi",
          src: require("../../assets/footer/logo-ncbi.webp"),
          url: "",
        },
        {
          name: "ensembl",
          src: require("../../assets/footer/logo-ensembl.webp"),
          url: "",
        },
        {
          name: "uniprot",
          src: require("../../assets/footer/logo-uniprot.webp"),
          url: "",
        },
        {
          name: "pfam",
          src: require("../../assets/footer/logo-pfam.webp"),
          url: "",
        },
        {
          name: "go",
          src: require("../../assets/footer/logo-go.webp"),
          url: "",
        },
        {
          name: "kegg",
          src: require("../../assets/footer/logo-kegg.webp"),
          url: "",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #3b3b46;
  color: #fff;
  padding-top: px2rem(35);

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .footer-left {
  }

  .footer-company-title {
    display: flex;
    align-items: center;
    margin-bottom: px2rem(36);
  }

  .footer-company-name {
    color: #fff;
    font-size: px2rem(18);
    margin-left: px2rem(18);
  }

  .footer-company-logo {
    width: px2rem(60);
    height: px2rem(60);
    user-select: none;
  }

  .footer-company-info {
    &__text {
      margin-bottom: px2rem(20);
      font-size: px2rem(16);
      color: #fff;
    }
  }

  .footer-copyright {
    text-align: center;
    font-size: px2rem(16);
    background-color: #373743;
    line-height: px2rem(48);
    margin-top: px2rem(16);
  }

  .footer-right {
    position: absolute;
    right: px2rem(-300);
    top: 50%;
    transform: translateY(-50%);
  }

  .footer-link-title {
    font-size: px2rem(14);
    color: #fff;
    margin-bottom: px2rem(20);
  }

  .footer-link-list {
    display: flex;
  }

  .footer-link-item {
    width: px2rem(128);
    height: px2rem(76);
    background-color: #fff;
    border-radius: px2rem(6);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: px2rem(8);
    user-select: none;

    img {
      max-width: px2rem(100);
      max-height: px2rem(50);
    }
  }
}

@media screen and (max-width: 1280px) {
  .footer {
    .footer-right {
      right: 0;
    }

    .footer-link-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: px2rem(10);
      max-width: px2rem(500);
    }

    .footer-link-item {
      margin: 0;
    }
  }
}
</style>
